/**
 * This code is a mixin for embedding the Panda Video Preview.
 */

import { mapState } from 'vuex'

export default {
  data: () => ({
    thumbnailUrl: '',
    signedToken: '',
    playOpensFullscreen: false,
    playOpensFullscreenNative: false,
    preloadEmbed: true,
    paramIsDashboard: '&isDashboard=true',
    refresEmbedComputedKey: 0,
    externalVideoParams: {},
    loadingExternalDuration: true,
    externalPlayer: {},
  }),
  watch: {
    'liveInfo.status': {
      handler(value) {
        const isStreaming = this.isStreamingRightNow
        const isCDN = this.showCDN
        const isLive = this.isPlayerLiveState
        const vm = this

        if (value === 'finished_imported') {
          setTimeout(() => {
            vm.paramIsDashboard = ''
          }, 10000)
        }

        if ((isStreaming && !isCDN) || !isLive) {
          this.paramIsDashboard = '&isDashboard=true'
        }
      },
      deep: true,
    },
    embedPage: {
      handler() {
        if (this.video.video_source) {
          if (
            this.video.video_source === 'youtube' ||
            this.video.video_source === 'vimeo'
          ) {
            const container = document.querySelector(
              `#pandaexternal-${this.video.video_external_id}`
            )
            if (container) {
              this.embedPageExternal()
            }
          } else {
            this.embedPageExternal()
          }
        }
      },
      deep: true,
      cache: false,
    },
  },
  created() {
    this.$root.$on('forceRecomputeEmbedPage', () => {
      this.refresEmbedComputedKey++
    })
  },
  methods: {
    embedPageExternal() {
      const _this = this
      if (
        !document.querySelector(
          `script[src="https://player${
            process.env.VUE_APP_ENV === 'staging' ? '-staging' : ''
          }.pandavideo.com.br/player.external.js"]`
        )
      ) {
        let s = document.createElement('script')
        s.src = `https://player${
          process.env.VUE_APP_ENV === 'staging' ? '-staging' : ''
        }.pandavideo.com.br/player.external.js`
        s.async = true
        document.head.appendChild(s)
      }

      window.pandaexternaltag = window.pandaexternaltag || []

      const pushObject = {
        ...{
          l: this.video.pullzone_name,
          onError(e) {
            if (e.message === 'youtube iframe was not found') {
              if (
                document.querySelector(`iframe[src="${_this.video.video_url}"]`)
              ) {
                _this.embedPageExternal()
              }
            } else {
              console.error(e)
            }
          },
          refreshConfig: true,
        },
        ..._this.externalVideoParams,
      }

      if (this.video.video_source === 'youtube') {
        pushObject['t'] = 'yt'
      } else if (this.video.video_source === 'vimeo') {
        pushObject['t'] = 'vimeo'
      } else {
        pushObject['v'] = this.video.video_external_id
      }

      window.pandaexternaltag.push(() => {
        // eslint-disable-next-line
        const player = new PandaExternalPlayer(
          `pandaexternal-${_this.video.video_external_id}`,
          {
            onReady: () => {
              if (!_this.video.length) {
                _this.$root.$emit('defineTimeVideo', player.getDuration())
              }
            },
            ...pushObject,
          }
        )
        _this.externalPlayer = player
      })
      this.$root.$on('setBookmarks', (data) => {
        _this.externalPlayer.setBookmarks(data)
      })
      this.$root.$on('setCtas', (data) => {
        if (data) _this.externalPlayer.setCtas(data)
      })
    },
    stripRawEmbed(string) {
      let finalString = string
      const iframeTagIndex = [
        finalString.indexOf('<iframe'),
        finalString.indexOf('</iframe>') + 9,
      ]
      finalString = finalString.slice(iframeTagIndex[0], iframeTagIndex[1])
      const iframeSrc = `${
        finalString.split('src="')[1].split('&')[0]
      }&controls=progress&pandaBranding=false`

      const srcAttrIndex = [
        finalString.indexOf('src="') + 5,
        finalString.indexOf('" style='),
      ]
      const srcContent = finalString.slice(srcAttrIndex[0], srcAttrIndex[1])
      finalString = finalString.replace(srcContent, iframeSrc)
      return finalString
    },
    embedPageGet() {
        this.refresEmbedComputedKey
        const profileNotSet = !Object.keys(this.profile).length
        const isVideoPage = this.$route.name === 'VideoPage'

        if (isVideoPage && profileNotSet) return

        /* eslint-disable */
        const date = new Date().getTime()
        this.thumbnailUrl = this.$store.state.video.video.thumbnail
        const smartSearchVal = this.$store.state.video?.smartSearch ?? false
        let jwtToken = this.signedToken
        let embedToBeReturned = ''
        if (/NewLive/g.test(this.$route.name)) {
          embedToBeReturned = `<div class="iframe" style="position:relative;padding-top:${
            this.aspectRatio
          };"><iframe id="panda-player" src="${
            this.isPlayerLiveState ? this.livePlayer : this.video.video_player
          }${this.isPlayerLiveState ? '&isLive=true&autoplay=true' : ''}${
            this.paramIsDashboard
          }${this.showLiveTitle ? `&title=${this.video.title}` : ''}`
        } else {
          embedToBeReturned = `<div class="iframe" style="position:relative;padding-top:${this.aspectRatio};"><iframe id="panda-player" src="${this.video.video_player}&isDashboard=true`
        }
        let queryParams = `${
          this.video.audios ? '&audios=' + this.video.audios.length : ''
        }${'&autoplay=' + (this.profile?.vsl?.autoplay || false)}${
          '&muted=' + (this.profile?.vsl?.mutedIndicatorIcon || false)
        }&refreshConfig=true&pandaBranding=${
          this.$store.state.video.profile?.vsl?.pandaBranding
        }${
          this.$store.state.video.profile.vsl?.disablePause
            ? '&disablePause=true'
            : '&disablePause=false'
        }${this.profile.vsl?.smartAutoplay ? '&smartAutoplay=true' : ''}${
          this.thumbnailUrl
            ? '&thumbnail=' + this.thumbnailUrl + '?' + date
            : ''
        }${
          this.$store.state.video.profile?.controls
            ? `&controls=${this.$store.state.video.profile?.controls}`
            : ''
        }${
          this.profile.vsl?.alternativeProgress
            ? '&alternativeProgress=true'
            : '&alternativeProgress=false'
        }${
          this.profile?.hideControlsOnStart ? '&hideControlsOnStart=true' : ''
        }${
          this.profile.vsl?.alternativeProgress2xLimit &&
          this.profile.vsl?.alternativeProgress
            ? '&alternativeProgress2xLimit=' +
              this.profile.vsl?.alternativeProgress2xLimit
            : ''
        }${
          this.profile.vsl?.alternativeProgressHeight &&
          this.profile.vsl?.alternativeProgress
            ? '&alternativeProgressHeight=' +
              this.profile.vsl?.alternativeProgressHeight
            : ''
        }${
          this.profile.vsl?.alternativeProgressVelocity &&
          this.profile.vsl?.alternativeProgress
            ? '&alternativeProgressVelocity=' +
              this.profile.vsl?.alternativeProgressVelocity
            : ''
        }${
          this.profile.vsl?.alternativeProgressDefaultVelocity &&
          this.profile.vsl?.alternativeProgress
            ? '&alternativeProgressDefaultVelocity=' +
              this.profile.vsl?.alternativeProgressDefaultVelocity
            : ''
        }${
          '&mutedIndicatorIcon=' +
          (this.profile?.vsl?.mutedIndicatorIcon || false)
        }${
          this.profile.vsl?.mutedIndicatorTextTop &&
          this.profile.vsl?.mutedIndicatorIcon
            ? '&mutedIndicatorTextTop=' +
              this.profile.vsl?.mutedIndicatorTextTop
            : ''
        }${
          this.profile.vsl?.mutedIndicatorFontSize
            ? '&mutedIndicatorFontSize=' +
              this.profile.vsl?.mutedIndicatorFontSize
            : ''
        }${
          this.profile.general?.captionsFontSize
            ? `&captionsFontSize=${this.profile.general?.captionsFontSize}`
            : ''
        }${
          this.profile.vsl?.mutedIndicatorTextBottom &&
          this.profile.vsl?.mutedIndicatorIcon
            ? '&mutedIndicatorTextBottom=' +
              this.profile.vsl?.mutedIndicatorTextBottom
            : ''
        }${
          this.profile.vsl?.mutedIndicatorTextColor
            ? '&mutedIndicatorTextColor=' +
              this.profile.vsl?.mutedIndicatorTextColor
            : ''
        }${
          this.profile.vsl?.mutedIndicatorBackgroundColor
            ? '&mutedIndicatorBackgroundColor=' +
              this.profile.vsl?.mutedIndicatorBackgroundColor
            : ''
        }${
          this.profile.saveProgress?.saveProgress
            ? '&saveProgress=true'
            : '&saveProgress=false'
        }${
          this.profile.saveProgress?.saveProgressScreen
            ? '&saveProgressScreen=true'
            : '&saveProgressScreen=false'
        }${
          this.profile.saveProgress?.saveProgressBackgroundOpacityFormated &&
          this.profile.saveProgress?.saveProgressScreen
            ? '&saveProgressBackgroundOpacity=' +
              this.profile.saveProgress?.saveProgressBackgroundOpacityFormated /
                100
            : ''
        }${
          this.profile.saveProgress?.saveProgressTitle &&
          this.profile.saveProgress?.saveProgressScreen
            ? '&saveProgressTitle=' +
              this.profile.saveProgress?.saveProgressTitle
            : ''
        }${
          this.profile.saveProgress?.saveProgressButton1Title &&
          this.profile.saveProgress?.saveProgressScreen
            ? '&saveProgressButton1Title=' +
              this.profile.saveProgress?.saveProgressButton1Title
            : ''
        }${
          this.profile.saveProgress?.saveProgressButton2Title &&
          this.profile.saveProgress?.saveProgressScreen
            ? '&saveProgressButton2Title=' +
              this.profile.saveProgress?.saveProgressButton2Title
            : ''
        }${this.signedToken ? `&watermark=${jwtToken}` : ''}${
          this.profile.vsl?.disableForward
            ? '&disableForward=' + this.profile.vsl?.disableForward
            : '&disableForward=false'
        }${this.playOpensFullscreen ? '&playOpensFullscreen=true' : ''}${
          this.playOpensFullscreenNative
            ? '&playOpensFullscreenNative=true'
            : ''
        }${
          this.profile.vsl?.mutedIndicatorIcon
            ? '&mutedIndicatorSize=' + this.profile.vsl?.mutedIndicatorSize
            : ''
        }${
          this.profile.vsl?.mutedIndicatorIcon
            ? '&mutedIndicatorBorderSize=' +
                this.profile.vsl?.mutedIndicatorBorderSize || 0
            : ''
        }${
          this.profile.vsl?.mutedIndicatorIcon
            ? '&mutedIndicatorAnimation=' +
              this.profile.vsl?.mutedIndicatorAnimation
            : ''
        }${
          this.profile.vsl?.mutedIndicatorIcon &&
          !['default', 'custom'].includes(
            this.profile.vsl?.mutedIndicatorAnimation
          ) &&
          this.profile.vsl?.mutedIndicatorLoop
            ? '&mutedIndicatorLoop=true&mutedIndicatorLoopDuration=' +
              this.profile.vsl?.mutedIndicatorLoopDuration
            : ''
        }${
          this.profile.vsl?.mutedIndicatorIcon &&
          this.profile.vsl?.mutedIndicatorAnimation === 'custom'
            ? '&customMutedIndicatorId=' +
              this.profile.vsl?.customMutedIndicatorId
            : ''
        }${'&smallMutedIcon=' + this.profile.vsl?.smallMutedIcon}${
          this.profile.general?.bigPlayButtonSize
            ? '&bigPlayButtonSize=' + this.profile.general?.bigPlayButtonSize
            : ''
        }${
          '&showPreviewThumbs=' +
          (this.profile?.general?.showPreviewThumbs || true)
        }${
          this.profile.vsl?.defaultLanguage
            ? '&defaultLanguage=' + this.profile.vsl?.defaultLanguage
            : ''
        }${
          this.profile.general?.bigPlayButtonIconSize
            ? '&bigPlayButtonIconSize=' +
              this.profile.general?.bigPlayButtonIconSize
            : ''
        }${this.preloadEmbed ? '' : '&preload=false'}${
          this.profile.colors?.controlsColor
            ? '&controlsColor=' + this.profile.colors.controlsColor
            : ''
        }${
          this.profile.colors?.primaryColor
            ? '&primaryColor=' + this.profile.colors.primaryColor
            : ''
        }${smartSearchVal ? '&smartSearch=' + smartSearchVal : ''}`
        if (this.isExternalSourceVideo) {
          const urlParams = new URLSearchParams(queryParams)
          const objParams = {}
          for (let [item, value] of urlParams) {
            if (value !== 'false' && value) {
              if (!isNaN(value)) value = Number(value)
              else value = value.toString()
              objParams[item] = value
            }
          }
          if (objParams.hasOwnProperty('controls')) objParams.controls += ','
          this.externalVideoParams = objParams

          if (this.video.video_source === 'youtube')
            return `<iframe width="560" height="315" src="${this.video.video_url}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen style="display:none" data-style="height: 200%; top: -50%;max-height: inherit;pointer-events: none;"></iframe>`
          if (this.video.video_source === 'vimeo')
            return `<iframe width="560" height="315" src="${this.video.video_url}" frtameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen style="display:none" data-style="height: 200%; top: -50%;max-height: inherit;pointer-events: none;"></iframe>`
          return ''
        }

        embedToBeReturned += `${queryParams}" style="border:none;position:absolute;top:0;height:100%;width:100%" allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture" allowfullscreen=true></iframe></div>`
        
        return embedToBeReturned
    },
  },
  computed: {
    ...mapState('video', {
      profile: 'profile',
    }),
    rawEmbedPage: {
      get: function () {
        const rawIframe = this.stripRawEmbed(this.embedPage)
        return rawIframe
      },
    },
    aspectRatio() {
      const { width, height } = this.video
      let ratio = height / width

      if (Number.isNaN(ratio)) {
        ratio = 9 / 16
      }

      return `${ratio * 100}%`
    },
  },
}
